<div class="ion-text-center">
    <ion-text>Wie hast Du Dich während des Zeitfensters gefühlt?</ion-text>
    <plugin-rating-bar [(rating)]="rating" [titles]="['Sehr schlecht', 'Schlecht', 'Weniger gut', 'Mittelmäßig', 'Okay', 'Gut', 'Sehr gut']" [readonly]="readOnly"></plugin-rating-bar>
</div>
